import Input from '@/components/ui/inputFormik';
import { logInVerifyOtp } from '@/services/auth';
import useCheckout from '@/store/checkout.store';
import { decodeJwt } from '@/utils/global';
import { event_user_auth } from '@/utils/gtm';
import { otpValidation } from '@/utils/validation/auth';
import { setCookie } from 'cookies-next';
import { Form, Formik } from 'formik';
import { getSession, signIn } from 'next-auth/react';
import { useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';
import useSearchParams from '@/hooks/useSearchParams';

const VerifyMobileOtp = ({ verifyOtpForValue, setAuth, t }) => {
  const locale = useLocale();
  const { rememberMe, mobileNumber } = verifyOtpForValue;
  const { clearCheckout, setActiveShippingMethod } = useCheckout();
  const { getFilterObj } = useSearchParams();
  const { push } = useRouter();

  const handleSubmit = async ({ otp }, { setSubmitting }) => {
    const response = await logInVerifyOtp(mobileNumber, otp);
    if (!response?.data || response?.error?.success === 'false') {
      toast.error(t(response?.error?.error.replace('.', '')));
    } else {
      const res = await signIn('credentials', {
        token: response?.data?.token,
        user: JSON.stringify({
          id: response?.data?.user?.id,
          store_id: response?.data?.user?.store_id,
          email: response?.data?.user?.email,
          firstname: response?.data?.user?.firstname,
          lastname: response?.data?.user?.lastname,
          mobilenumber: response?.data?.data?.user?.custom_attributes?.find(
            (attr) => attr.attribute_code === 'mobilenumber'
          )?.value,
          rememberMe,
        }),
        callbackUrl: '/',
        redirect: false,
      });

      if (!res.ok && res.status !== 200) {
        toast.error(
          locale === 'en'
            ? 'Mobile number or OTP is wrong, please try again'
            : 'خطأ فى الرقم الموبايل او الكود المرسل'
        );
      } else {
        clearCheckout()
        setActiveShippingMethod(null)
        const session = await getSession();

        if (session?.mage) {
          const decodedToken = decodeJwt(session?.mage, false);
          const expires =
            rememberMe && decodedToken?.exp
              ? new Date(decodedToken.exp * 1000)
              : new Date(Date.now() + 1 * 24 * 60 * 60 * 1000);

          setCookie('mage', session?.mage, { expires });
          event_user_auth(session?.user);
          toast.success(
            locale === 'en'
              ? 'You logged in successfully'
              : 'تم تسجيل الدخول بنجاح'
          );
          setAuth(false);
          if (getFilterObj?.url && getFilterObj?.url.startsWith('/user')) {
            push(getFilterObj?.url);
          }
        }
      }
    }
    setSubmitting(false);
  };

  return (
    <>
      <p className='my-2 flex flex-wrap items-center justify-center gap-1 px-4 text-center lg:my-4'>
        <span className='text-sm font-bold text-red-600 lg:text-xl'>
          {t('Enter your OTP')}
        </span>
        <span className='font-medium max-lg:text-xs'>
          {t('sent to your mobile number')}
        </span>
      </p>
      <Formik
        onSubmit={handleSubmit}
        initialValues={{ otp: '' }}
        validationSchema={otpValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form className='flex flex-col gap-2 px-2 pb-4 lg:gap-4 lg:px-4'>
            <Input name='otp' id='otp' title={t('Otp')} />
            <button
              type='submit'
              className='flex w-full cursor-pointer items-center justify-center gap-3 rounded-lg bg-red-600 py-1 font-bold text-white hover:bg-red-600/70 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-red-600 max-lg:text-sm lg:py-1.5'
              disabled={isSubmitting}
            >
              {isSubmitting && (
                <span className='border-primary-500 size-4 animate-spin rounded-full border-t border-r py-1 max-lg:size-2' />
              )}
              {t('Verify')}
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default VerifyMobileOtp;
